
import url from 'url';

import _ from 'lodash';

import Method from 'server/js/lib/method.js';
import util from 'server/js/util';

import {
	enrichNative as enrichNativeError,
} from 'error';


function Host (options, server) {
	options = _.defaults({}, options, {
		methods: {},
	});

	this._server = server;

	_(options.methods)
		.pickBy((method, name) => {
			return name !== 'index';
		})
		.mapValues((method, name) => {
			if (method instanceof Method) {
				return method;
			}
			return new Method(method, '/' + name, this);
		})
		.mapKeys((method, name) => {
			return name.split('/').join('.');
		})
		.each((method, name) => {
			_.set(this, name, method);
		});
}

Host.prototype = {
	_contentTypes: {
		'json': 'application/json; charset=utf-8',
		'form': 'application/x-www-form-urlencoded; charset=utf-8',
		'formData': 'multipart/form-data',
	},

	_defaultHeaders: function (options) {
		const contentType = this._contentTypes[options.bodyType]
			|| this._contentTypes.json;

		return _.defaultsDeep({}, options, {
			headers: {
				'Content-Type': contentType,
				'x-pretty-identity-document-mode': true,
			},
		});
	},

	_transformQuery: function (options) {
		if (!('query' in options)) {
			return options;
		}

		const base = url.parse(options.url);
		const query = options.query;
		const withQuery = _.set(base, 'query', query);

		return _.extend({}, options, { url: url.format(withQuery) });
	},

	_transformBody: function (options) {
		const transform = util.options.body[options.bodyType] || util.options.body.json;
		return transform(options);
	},

	_beforeAjax: function (options) {
		options.body = options.body || options.data;
		delete options.data;
		options = _.flowRight(
			this._defaultHeaders,
			this._transformQuery,
			this._transformBody
		).call(this, options);
		return options;
	},

	_parseResponse: util.over.json((json, response) => response),

	_filterHttpError: util.filter.httpError,

	_filterJsonEncodedError: util.filter.jsonEncodedError,

	_afterAjax: function (promise) {
		return promise
			.catch(e => {
				throw enrichNativeError(e);
			})
			.then(this._filterJsonEncodedError)
			.then(this._filterHttpError)
			.then(this._parseResponse);
	},
};

module.exports = Host;
